module.exports = __webpack_public_path__ + "img/slider-home-1.8e8d919e.webp";